module.exports = __webpack_public_path__ + "img/agent-5.png";